export default "__VITE_ASSET__BbyLKhvt__"